import CSSModules from "react-css-modules";
import styles from "./cardMakeAPayment.scss";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Tooltip from '../../src/components/common/material/Tooltip';
import IconButton from '../../src/components/common/material/IconButton';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";


@connect(state => ({
    messages: state.i18n.messages,
  }),
null
)
@CSSModules(styles, { allowMultiple: true })
class PaymentMethodSelect extends React.Component {

  static propTypes = {
    last4Digits: PropTypes.string,
    selected: PropTypes.string,
    selectedRedNote: PropTypes.string,
    onChange: PropTypes.func,
    hasPaymentMethod: PropTypes.bool,
  };

  handleOnClick = (event) => {
    const {value} = event.target;
    this.props.onChange(value);
  }

  currenPaymentMethodMsg = () => {
    if (this.props.last4Digits.length == 4) {
      return 'card.paymentMethod.current.debitRcc.text';
    } else {
      return 'card.paymentMethod.current.mail.text';
    }
  }

  render() {
    const IconButtonTooltip = Tooltip(IconButton);
    const currenPaymentMethod = this.currenPaymentMethodMsg();
    const options = [];
    if(this.props.hasPaymentMethod) {
      options.push(
        {value: 'CURRENT', msgId: currenPaymentMethod, redNote: this.props.selectedRedNote},
      );
    }
    options.push(
      {value: 'DEBIT', msgId: 'card.paymentMethod.debit.text', className: "withArrow"},
      // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
      // {value: 'RCC', msgId:'card.paymentMethod.rcc.text', className: "withArrow", tooltip: {text: this.props.messages['card.paymentMethod.rcc.tooltipText']}},
    );

    return (
      <ul styleName="paymentMethods">
        {
          options.map((option) => {
            const selected = option.value === this.props.selected;
            return (
              <li styleName="paymentMethod" data-at={`payment-method-select-${option.value}`} key={option.value}>
                <label styleName={classNames(option.className, {selected})}>
                  <input type="radio" name="paymentMethod" value={option.value} checked={selected} onChange={this.handleOnClick}/>
                  <FormattedMessage id={option.msgId} values={{last4Digits : this.props.last4Digits}}/>
                  {option.tooltip && <IconButtonTooltip tooltipShowOnClick={true} icon="info_outline" tooltip={option.tooltip.text} />}
                </label>
                {option.redNote && <span style={{color: 'red', marginTop: 8, fontSize: 12}}>{option.redNote}</span>}
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default PaymentMethodSelect;



// WEBPACK FOOTER //
// ./src/card/PaymentMethodSelect.js